<div class="form-group mb-7">
    <div class="input-container">
        <textarea
            rows="{{ rows }}"
            cols="{{ cols }}"
            class="form-control no-outline text-area-control"
            [formControl]="control"
            [required]="control.getError('required')"
            placeholder="{{ control.getError('required') ? '' : label }}"
            id="{{ label }}"
        >
        </textarea>
        @if (control.getError('required')) {
            <label for="{{ label }}">{{ label }}</label>
        }
    </div>
    @if (control.invalid && (control.dirty || control.touched)) {
        <div class="warning-alert">
            @if (control.errors?.['required']) {
                <div class="mt-2 warning-message">
                    {{ 'CONTACT.form_messages.required' | translate }}
                </div>
            }
            @if (control.errors?.['minlength']) {
                <div class="mt-2 warning-message">
                    {{ 'CONTACT.form_messages.minLength' | translate: { length: control.errors?.['minlength']['requiredLength'] } }}
                </div>
            }
            @if (control.errors?.['maxlength']) {
                <div class="mt-2 warning-message">
                    {{ 'CONTACT.form_messages.maxLength' | translate: { length: control.errors?.['maxlength']['requiredLength'] } }}
                </div>
            }
            @if (!control.errors?.['minlength'] && control.errors?.['trimError']) {
                <div class="mt-2 warning-message">
                    {{ 'CONTACT.form_messages.emptySpaces' | translate }}
                </div>
            }
        </div>
    }
</div>
